"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _context20;

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  getUnreadNotificationsCount: true,
  createNotification: true,
  markNotificationAsRead: true,
  deleteNotification: true,
  markAllNotificationsAsRead: true,
  getNotifications: true,
  getAllNotifications: true
};
exports.getUnreadNotificationsCount = getUnreadNotificationsCount;
exports.createNotification = createNotification;
exports.markNotificationAsRead = markNotificationAsRead;
exports.deleteNotification = deleteNotification;
exports.markAllNotificationsAsRead = markAllNotificationsAsRead;
exports.getNotifications = getNotifications;
exports.getAllNotifications = getAllNotifications;

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _environment = require("../environment");

var _sortingFiltering = require("../utils/sorting-filtering");

var _models = require("./models");

_forEachInstanceProperty(_context20 = _Object$keys(_models)).call(_context20, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _models[key];
    }
  });
});

function getUnreadNotificationsCount() {
  return _getUnreadNotificationsCount.apply(this, arguments);
}

function _getUnreadNotificationsCount() {
  _getUnreadNotificationsCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", (0, _environment.getRoute)('NotificationServices').then(function (base) {
              return "".concat(base, "/v1/notifications/unread");
            }).then( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url) {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'GET'
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x8) {
                return _ref2.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(response) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x9) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getUnreadNotificationsCount.apply(this, arguments);
}

function createNotification(_x, _x2, _x3) {
  return _createNotification.apply(this, arguments);
}

function _createNotification() {
  _createNotification = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(category, type, data) {
    return _regenerator.default.wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", (0, _environment.getRoute)('NotificationServices').then(function (base) {
              var _context5, _context6;

              return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "".concat(base, "/v1/notifications/category/")).call(_context6, category, "/type/")).call(_context5, type);
            }).then( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(url) {
                return _regenerator.default.wrap(function _callee5$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)(data),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x10) {
                return _ref4.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee6);
  }));
  return _createNotification.apply(this, arguments);
}

function markNotificationAsRead(_x4) {
  return _markNotificationAsRead.apply(this, arguments);
}

function _markNotificationAsRead() {
  _markNotificationAsRead = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(notificationId) {
    return _regenerator.default.wrap(function _callee8$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", (0, _environment.getRoute)('NotificationServices').then(function (base) {
              var _context9;

              return (0, _concat.default)(_context9 = "".concat(base, "/v1/notifications/read/")).call(_context9, notificationId);
            }).then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
                return _regenerator.default.wrap(function _callee7$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        return _context10.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x11) {
                return _ref5.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee8);
  }));
  return _markNotificationAsRead.apply(this, arguments);
}

function deleteNotification(_x5) {
  return _deleteNotification.apply(this, arguments);
}

function _deleteNotification() {
  _deleteNotification = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(notificationId) {
    return _regenerator.default.wrap(function _callee10$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", (0, _environment.getRoute)('NotificationServices').then(function (base) {
              var _context12;

              return (0, _concat.default)(_context12 = "".concat(base, "/v1/notifications/")).call(_context12, notificationId);
            }).then( /*#__PURE__*/function () {
              var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(url) {
                return _regenerator.default.wrap(function _callee9$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        return _context13.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'DELETE'
                        }));

                      case 1:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x12) {
                return _ref6.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee10);
  }));
  return _deleteNotification.apply(this, arguments);
}

function markAllNotificationsAsRead() {
  return _markAllNotificationsAsRead.apply(this, arguments);
}

function _markAllNotificationsAsRead() {
  _markAllNotificationsAsRead = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
    return _regenerator.default.wrap(function _callee12$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", (0, _environment.getRoute)('NotificationServices').then(function (base) {
              return "".concat(base, "/v1/notifications/read");
            }).then( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(url) {
                return _regenerator.default.wrap(function _callee11$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        return _context15.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee11);
              }));

              return function (_x13) {
                return _ref7.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee12);
  }));
  return _markAllNotificationsAsRead.apply(this, arguments);
}

function getNotifications(_x6) {
  return _getNotifications.apply(this, arguments);
}

function _getNotifications() {
  _getNotifications = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(options) {
    return _regenerator.default.wrap(function _callee15$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", (0, _environment.getRoute)('NotificationServices').then(function (base) {
              return "".concat(base, "/v1/notifications");
            }).then(function (base) {
              var url = new _url.default(base);
              (0, _sortingFiltering.applyFilter)(url, options);
              (0, _sortingFiltering.applyPaging)(url, options);

              if ((options === null || options === void 0 ? void 0 : options.types) && options.types.length > 0) {
                url.searchParams.set('types', options.types.join(','));
              }

              if (options === null || options === void 0 ? void 0 : options.messageTags) {
                url.searchParams.set('messageTags', encodeURIComponent((0, _stringify.default)(options.messageTags)));
              }

              return url.href;
            }).then( /*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(url) {
                return _regenerator.default.wrap(function _callee13$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        return _context17.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee13);
              }));

              return function (_x14) {
                return _ref8.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(resp) {
                return _regenerator.default.wrap(function _callee14$(_context18) {
                  while (1) {
                    switch (_context18.prev = _context18.next) {
                      case 0:
                        return _context18.abrupt("return", resp.json());

                      case 1:
                      case "end":
                        return _context18.stop();
                    }
                  }
                }, _callee14);
              }));

              return function (_x15) {
                return _ref9.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee15);
  }));
  return _getNotifications.apply(this, arguments);
}

function getAllNotifications(options) {
  return (0, _sortingFiltering.pagingAsyncIterator)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(startIndex) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", getNotifications((0, _objectSpread2.default)((0, _objectSpread2.default)({}, options), {}, {
                startIndex: startIndex
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x7) {
      return _ref.apply(this, arguments);
    };
  }());
}
